const serializeForInsert = require('./serialize-for-insert')

module.exports = {
  serializeForInsert
}
